import { WDHCarousel } from '../../../../wdh-feature/wdh-carousel';
var carousel = new WDHCarousel();
carousel.run();